//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { IApiConfig } from './apiConfig';
export class ApiBase {
  apiConfig: IApiConfig;

  constructor(apiConfig: IApiConfig) {
    this.apiConfig = apiConfig;
  }

  protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: await this.apiConfig.getAuthorizationToken(),
    };
    return Promise.resolve(options);
  };
}

export interface IActorClient {

    /**
     * Retrieves a list of Postal codes for the specified countryId.
     * @param countryId The three-letter ISO-code for the country.
     * @return Success
     */
    getPostalCodes(countryId: string): Promise<ComboboxItem[]>;

    /**
     * Retrieves a list of countries.
     * @return Success
     */
    getCountries(): Promise<ComboboxItem[]>;

    /**
     * Retrieves a list of insurance companies.
     * @return Success
     */
    getInsuranceCompanies(): Promise<ComboboxItem[]>;

    /**
     * Retrieves a list of insurance companies for the provided countryId.
     * @param countryId The three-letter ISO-code for the country.
     * @return Success
     */
    getInsuranceCompanies2(countryId: string): Promise<ComboboxItem[]>;

    /**
     * Fetches a list of VIAP.Domain.ReadModels.UserDto's in the context of agents.
     * @return Success
     */
    getAgents(): Promise<UserDto[]>;

    /**
     * Retrieves a list of VolvoWorkshops.
     * @return Success
     */
    getVolvoWorkshops(): Promise<ComboboxItem[]>;

    /**
     * Retrieves a list of Rental car providers.
     * @return Success
     */
    getRentalCarProviders(): Promise<ComboboxItem[]>;

    /**
     * Returns a RentalCarProvider by Id.
     * @return Success
     */
    getRentalCarProvider(id: number): Promise<DetailedRentalCarProviderDto>;
}

export class ActorClient extends ApiBase implements IActorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrieves a list of Postal codes for the specified countryId.
     * @param countryId The three-letter ISO-code for the country.
     * @return Success
     */
    getPostalCodes(countryId: string): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Actor/GetPostalCodes/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPostalCodes(_response);
        });
    }

    protected processGetPostalCodes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Retrieves a list of countries.
     * @return Success
     */
    getCountries(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Actor/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Retrieves a list of insurance companies.
     * @return Success
     */
    getInsuranceCompanies(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Actor/GetInsuranceCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceCompanies(_response);
        });
    }

    protected processGetInsuranceCompanies(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Retrieves a list of insurance companies for the provided countryId.
     * @param countryId The three-letter ISO-code for the country.
     * @return Success
     */
    getInsuranceCompanies2(countryId: string): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Actor/GetInsuranceCompanies/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceCompanies2(_response);
        });
    }

    protected processGetInsuranceCompanies2(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Fetches a list of VIAP.Domain.ReadModels.UserDto's in the context of agents.
     * @return Success
     */
    getAgents(): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/Actor/GetAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgents(_response);
        });
    }

    protected processGetAgents(response: Response): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * Retrieves a list of VolvoWorkshops.
     * @return Success
     */
    getVolvoWorkshops(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Actor/GetVolvoWorkshops";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVolvoWorkshops(_response);
        });
    }

    protected processGetVolvoWorkshops(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Retrieves a list of Rental car providers.
     * @return Success
     */
    getRentalCarProviders(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Actor/GetRentalCarProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRentalCarProviders(_response);
        });
    }

    protected processGetRentalCarProviders(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a RentalCarProvider by Id.
     * @return Success
     */
    getRentalCarProvider(id: number): Promise<DetailedRentalCarProviderDto> {
        let url_ = this.baseUrl + "/api/Actor/GetRentalCarProvider/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRentalCarProvider(_response);
        });
    }

    protected processGetRentalCarProvider(response: Response): Promise<DetailedRentalCarProviderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DetailedRentalCarProviderDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DetailedRentalCarProviderDto>(null as any);
    }
}

export interface IAgreementClient {

    /**
     * Fetch agreements based on agreement grouping.
     * @return Success
     */
    agreementAll(): Promise<ComboboxItem[]>;

    /**
     * Get more information about a specific agreement.
     * @param id Id of the agreement. Four-letter abbreviation.
     * @return Success
     */
    agreement(id: string): Promise<AgreementDto>;

    /**
     * Validates the request to see if the Case is covered by the conditions specified in the Agreement.
     * @param body (optional) Required fields that can be subject to validation for an agreement.
     * @return Success
     */
    calculateCaseCoverageStatus(body: CaseCoverageStatusRequest | undefined): Promise<CaseCoverageStatus>;
}

export class AgreementClient extends ApiBase implements IAgreementClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Fetch agreements based on agreement grouping.
     * @return Success
     */
    agreementAll(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Agreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAgreementAll(_response);
        });
    }

    protected processAgreementAll(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get more information about a specific agreement.
     * @param id Id of the agreement. Four-letter abbreviation.
     * @return Success
     */
    agreement(id: string): Promise<AgreementDto> {
        let url_ = this.baseUrl + "/api/Agreement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAgreement(_response);
        });
    }

    protected processAgreement(response: Response): Promise<AgreementDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementDto>(null as any);
    }

    /**
     * Validates the request to see if the Case is covered by the conditions specified in the Agreement.
     * @param body (optional) Required fields that can be subject to validation for an agreement.
     * @return Success
     */
    calculateCaseCoverageStatus(body: CaseCoverageStatusRequest | undefined): Promise<CaseCoverageStatus> {
        let url_ = this.baseUrl + "/api/Agreement/CalculateCaseCoverageStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateCaseCoverageStatus(_response);
        });
    }

    protected processCalculateCaseCoverageStatus(response: Response): Promise<CaseCoverageStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseCoverageStatus;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseCoverageStatus>(null as any);
    }
}

export interface ICaseClient {

    /**
     * Search all cases in VIS by individual parameters./>.
     * @param body (optional) If you increment parameters.ResultIndex.ResultIndex by the same amount as parameters.ResultQty.ResultQty you get the next "page" of results.
     * @return Success
     */
    search(body: CaseSearchRequest | undefined): Promise<CaseSearchResultsDto>;

    /**
     * Get the case with the specified id.
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Promise<CaseDto>;

    /**
     * Get the a case incident location with the specified caseid id.
     * @param id (optional) 
     * @return Success
     */
    getIncidentLocationByCaseId(id: string | undefined): Promise<Location>;

    /**
     * Get cases by registrationNumber registrationNumber.
     * @param registrationNumber (optional) 
     * @param visCaseId (optional) 
     * @return Success
     */
    getCasesByRegistrationNumber(registrationNumber: string | undefined, visCaseId: number | undefined): Promise<CaseSearchResultDto[]>;

    /**
     * Get the case with the specified visCaseId.
     * @param visCaseId (optional) 
     * @return Success
     */
    getByVisCaseId(visCaseId: number | undefined): Promise<CaseDto>;

    /**
     * Create a new case.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    create(body: CaseDto | undefined): Promise<CaseDto>;

    /**
     * Cancel the case by cmd.CaseId.CaseId.
     * @param body (optional) The cmd.CaseId.CaseId of the case to be cancelled and the  cmd.ReasonId.ReasonId for cancellation.
     * @return Success
     */
    cancel(body: CancelCaseCommand | undefined): Promise<CaseAction>;

    /**
     * Resume the case by cmd.CaseId.CaseId.
     * @param body (optional) The cmd.CaseId.CaseId of the case to be resumed/> for cancellation.
     * @return Success
     */
    resume(body: ResumeCaseCommand | undefined): Promise<CaseAction>;

    /**
     * Updates the case.
     * @param body (optional) The case will be updated.
     * @return Success
     */
    update(body: CaseDto | undefined): Promise<CaseDto>;

    /**
     * Marks the case as completed, and transfers it to Viking.
     * @param body (optional) The case will be updated.
     * @return Success
     */
    fixedIt(body: FixedItCommand | undefined): Promise<CaseAction>;

    /**
     * Transfers the Case to Viking's back office.
     * @param body (optional) The case will be updated.
     * @return Success
     */
    sendToViking(body: SendCaseToVikingCommand | undefined): Promise<CaseAction>;

    /**
     * Checks if the case has any CaseActions of type Distributed with service Assistance that are marked as completed.
     * @param visCaseId (optional) 
     * @return Success
     */
    hasCompletedAssistance(visCaseId: number | undefined): Promise<boolean>;

    /**
     * Get a list of all available vehicle manufacturer brands (e.g. Volvo).
     * @return Success
     */
    getVehicleBrands(): Promise<ComboboxItem[]>;

    /**
     * Get a list of all available vehicle models for the provided brandId.
     * @return Success
     */
    getModels(brandId: string): Promise<ComboboxItem[]>;

    /**
     * Get a list of all available incident codes.
     * @return Success
     */
    getIncidentCodes(): Promise<ComboboxItem[]>;

    /**
     * Get a list of all available incident detail codes for the provided incidentCodeId.
    Note! Only Puncture is set up with any.
     * @return Success
     */
    getIncidentDetailCodes(incidentCodeId: string): Promise<ComboboxItem[]>;

    /**
     * Get a list of all available drivetrains (e.g. 4*4).
     * @return Success
     */
    getDriveTrains(): Promise<ComboboxItem[]>;

    /**
     * Get a list of all available fuel types (e.g. Diesel).
     * @return Success
     */
    getFuels(): Promise<ComboboxItem[]>;

    /**
     * Get a list of all available vehicle types as defined by Viking Assistance Group.
     * @return Success
     */
    getVehicleTypes(): Promise<ComboboxItem[]>;

    /**
     * Get the values home/away. For some reason this has not been implemented as a boolean.
     * @return Success
     */
    getHomeAway(): Promise<ComboboxItem[]>;

    /**
     * Get a list of all options for where the "customer" is waiting. Should not be relevant.
     * @return Success
     */
    getCustomerWaiting(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of case cancellation bases.
     * @return Success
     */
    getCancellationBases(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of insurance types.
     * @return Success
     */
    getInsuranceTypes(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of originCodes.
     * @return Success
     */
    getOriginCodes(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of controlStatusCodes.
     * @return Success
     */
    getInsuranceStatusCodes(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of codes describing where the keys to a vehicle have been placed.
     * @return Success
     */
    getKeyPlacementCodes(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of InfoCall descriptions.
     * @return Success
     */
    getInfoCallTexts(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of Logtypes.
     * @return Success
     */
    getLoggTypes(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of Logtypes.
     * @return Success
     */
    getDeadlineTypes(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of GetCallCenters.
     * @return Success
     */
    getCallCenters(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of ServiceTypes.
     * @return Success
     */
    getServices(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of ServiceTypes.
     * @return Success
     */
    getCaseStatuses(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of CaseStatuses.
     * @return Success
     */
    getCaseStatus(): Promise<ComboboxItem[]>;

    /**
     * Returns a list of CaseStatuses.
     * @return Success
     */
    getGroups(): Promise<ComboboxItem[]>;

    /**
     * Retrieves a Postalarea for the specified countryId and postalCode.
     * @param countryId The three-letter ISO-code for the country.
     * @param postalCode The postalCode.
     * @return Success
     */
    getPostalArea(countryId: string, postalCode: string): Promise<Item>;

    /**
     * Retrieves a list of CaseDeadlines for the specified languageCode .
     * @param languageCode The three-letter ISO-code for the country.
     * @return Success
     * @deprecated
     */
    getCaseDeadlines(languageCode: string): Promise<Item[]>;

    /**
     * Retrieves a list of CaseDeadlines.
     * @return Success
     */
    getCaseDeadlines2(): Promise<Item[]>;

    /**
     * Retrieves a list of languages .
     * @return Success
     */
    getLanguages(): Promise<Item[]>;

    /**
     * @param callCenterCountryCode (optional) 
     * @return Success
     */
    getSmsTemplates(callCenterCountryCode: string | undefined): Promise<Item[]>;
}

export class CaseClient extends ApiBase implements ICaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Search all cases in VIS by individual parameters./>.
     * @param body (optional) If you increment parameters.ResultIndex.ResultIndex by the same amount as parameters.ResultQty.ResultQty you get the next "page" of results.
     * @return Success
     */
    search(body: CaseSearchRequest | undefined): Promise<CaseSearchResultsDto> {
        let url_ = this.baseUrl + "/api/Case/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<CaseSearchResultsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSearchResultsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseSearchResultsDto>(null as any);
    }

    /**
     * Get the case with the specified id.
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Promise<CaseDto> {
        let url_ = this.baseUrl + "/api/Case/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDto>(null as any);
    }

    /**
     * Get the a case incident location with the specified caseid id.
     * @param id (optional) 
     * @return Success
     */
    getIncidentLocationByCaseId(id: string | undefined): Promise<Location> {
        let url_ = this.baseUrl + "/api/Case/GetIncidentLocationByCaseId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentLocationByCaseId(_response);
        });
    }

    protected processGetIncidentLocationByCaseId(response: Response): Promise<Location> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Location;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location>(null as any);
    }

    /**
     * Get cases by registrationNumber registrationNumber.
     * @param registrationNumber (optional) 
     * @param visCaseId (optional) 
     * @return Success
     */
    getCasesByRegistrationNumber(registrationNumber: string | undefined, visCaseId: number | undefined): Promise<CaseSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Case/GetCasesByRegistrationNumber?";
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (visCaseId === null)
            throw new Error("The parameter 'visCaseId' cannot be null.");
        else if (visCaseId !== undefined)
            url_ += "visCaseId=" + encodeURIComponent("" + visCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCasesByRegistrationNumber(_response);
        });
    }

    protected processGetCasesByRegistrationNumber(response: Response): Promise<CaseSearchResultDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSearchResultDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseSearchResultDto[]>(null as any);
    }

    /**
     * Get the case with the specified visCaseId.
     * @param visCaseId (optional) 
     * @return Success
     */
    getByVisCaseId(visCaseId: number | undefined): Promise<CaseDto> {
        let url_ = this.baseUrl + "/api/Case/GetByVisCaseId?";
        if (visCaseId === null)
            throw new Error("The parameter 'visCaseId' cannot be null.");
        else if (visCaseId !== undefined)
            url_ += "visCaseId=" + encodeURIComponent("" + visCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByVisCaseId(_response);
        });
    }

    protected processGetByVisCaseId(response: Response): Promise<CaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDto>(null as any);
    }

    /**
     * Create a new case.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    create(body: CaseDto | undefined): Promise<CaseDto> {
        let url_ = this.baseUrl + "/api/Case/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDto>(null as any);
    }

    /**
     * Cancel the case by cmd.CaseId.CaseId.
     * @param body (optional) The cmd.CaseId.CaseId of the case to be cancelled and the  cmd.ReasonId.ReasonId for cancellation.
     * @return Success
     */
    cancel(body: CancelCaseCommand | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/Case/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Resume the case by cmd.CaseId.CaseId.
     * @param body (optional) The cmd.CaseId.CaseId of the case to be resumed/> for cancellation.
     * @return Success
     */
    resume(body: ResumeCaseCommand | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/Case/Resume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResume(_response);
        });
    }

    protected processResume(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Updates the case.
     * @param body (optional) The case will be updated.
     * @return Success
     */
    update(body: CaseDto | undefined): Promise<CaseDto> {
        let url_ = this.baseUrl + "/api/Case/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDto>(null as any);
    }

    /**
     * Marks the case as completed, and transfers it to Viking.
     * @param body (optional) The case will be updated.
     * @return Success
     */
    fixedIt(body: FixedItCommand | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/Case/FixedIt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFixedIt(_response);
        });
    }

    protected processFixedIt(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Transfers the Case to Viking's back office.
     * @param body (optional) The case will be updated.
     * @return Success
     */
    sendToViking(body: SendCaseToVikingCommand | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/Case/SendToViking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendToViking(_response);
        });
    }

    protected processSendToViking(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Checks if the case has any CaseActions of type Distributed with service Assistance that are marked as completed.
     * @param visCaseId (optional) 
     * @return Success
     */
    hasCompletedAssistance(visCaseId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Case/HasCompletedAssistance?";
        if (visCaseId === null)
            throw new Error("The parameter 'visCaseId' cannot be null.");
        else if (visCaseId !== undefined)
            url_ += "visCaseId=" + encodeURIComponent("" + visCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasCompletedAssistance(_response);
        });
    }

    protected processHasCompletedAssistance(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get a list of all available vehicle manufacturer brands (e.g. Volvo).
     * @return Success
     */
    getVehicleBrands(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetVehicleBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVehicleBrands(_response);
        });
    }

    protected processGetVehicleBrands(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all available vehicle models for the provided brandId.
     * @return Success
     */
    getModels(brandId: string): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetModels/{brandId}";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModels(_response);
        });
    }

    protected processGetModels(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all available incident codes.
     * @return Success
     */
    getIncidentCodes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetIncidentCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentCodes(_response);
        });
    }

    protected processGetIncidentCodes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all available incident detail codes for the provided incidentCodeId.
    Note! Only Puncture is set up with any.
     * @return Success
     */
    getIncidentDetailCodes(incidentCodeId: string): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetIncidentDetailCodes/{incidentCodeId}";
        if (incidentCodeId === undefined || incidentCodeId === null)
            throw new Error("The parameter 'incidentCodeId' must be defined.");
        url_ = url_.replace("{incidentCodeId}", encodeURIComponent("" + incidentCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentDetailCodes(_response);
        });
    }

    protected processGetIncidentDetailCodes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all available drivetrains (e.g. 4*4).
     * @return Success
     */
    getDriveTrains(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetDriveTrains";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDriveTrains(_response);
        });
    }

    protected processGetDriveTrains(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all available fuel types (e.g. Diesel).
     * @return Success
     */
    getFuels(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetFuels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFuels(_response);
        });
    }

    protected processGetFuels(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all available vehicle types as defined by Viking Assistance Group.
     * @return Success
     */
    getVehicleTypes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetVehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVehicleTypes(_response);
        });
    }

    protected processGetVehicleTypes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get the values home/away. For some reason this has not been implemented as a boolean.
     * @return Success
     */
    getHomeAway(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetHomeAway";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHomeAway(_response);
        });
    }

    protected processGetHomeAway(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Get a list of all options for where the "customer" is waiting. Should not be relevant.
     * @return Success
     */
    getCustomerWaiting(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetCustomerWaiting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerWaiting(_response);
        });
    }

    protected processGetCustomerWaiting(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of case cancellation bases.
     * @return Success
     */
    getCancellationBases(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetCancellationBases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCancellationBases(_response);
        });
    }

    protected processGetCancellationBases(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of insurance types.
     * @return Success
     */
    getInsuranceTypes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetInsuranceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceTypes(_response);
        });
    }

    protected processGetInsuranceTypes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of originCodes.
     * @return Success
     */
    getOriginCodes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetOriginCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOriginCodes(_response);
        });
    }

    protected processGetOriginCodes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of controlStatusCodes.
     * @return Success
     */
    getInsuranceStatusCodes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetInsuranceStatusCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceStatusCodes(_response);
        });
    }

    protected processGetInsuranceStatusCodes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of codes describing where the keys to a vehicle have been placed.
     * @return Success
     */
    getKeyPlacementCodes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetKeyPlacementCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKeyPlacementCodes(_response);
        });
    }

    protected processGetKeyPlacementCodes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of InfoCall descriptions.
     * @return Success
     */
    getInfoCallTexts(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetInfoCallTexts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfoCallTexts(_response);
        });
    }

    protected processGetInfoCallTexts(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of Logtypes.
     * @return Success
     */
    getLoggTypes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetLoggTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoggTypes(_response);
        });
    }

    protected processGetLoggTypes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of Logtypes.
     * @return Success
     */
    getDeadlineTypes(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetDeadlineTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeadlineTypes(_response);
        });
    }

    protected processGetDeadlineTypes(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of GetCallCenters.
     * @return Success
     */
    getCallCenters(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetCallCenters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCallCenters(_response);
        });
    }

    protected processGetCallCenters(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of ServiceTypes.
     * @return Success
     */
    getServices(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServices(_response);
        });
    }

    protected processGetServices(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of ServiceTypes.
     * @return Success
     */
    getCaseStatuses(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetCaseStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseStatuses(_response);
        });
    }

    protected processGetCaseStatuses(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of CaseStatuses.
     * @return Success
     */
    getCaseStatus(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetCaseStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseStatus(_response);
        });
    }

    protected processGetCaseStatus(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Returns a list of CaseStatuses.
     * @return Success
     */
    getGroups(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/Case/GetGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Retrieves a Postalarea for the specified countryId and postalCode.
     * @param countryId The three-letter ISO-code for the country.
     * @param postalCode The postalCode.
     * @return Success
     */
    getPostalArea(countryId: string, postalCode: string): Promise<Item> {
        let url_ = this.baseUrl + "/api/Case/GetPostalArea/{countryId}/{postalCode}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined.");
        url_ = url_.replace("{postalCode}", encodeURIComponent("" + postalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPostalArea(_response);
        });
    }

    protected processGetPostalArea(response: Response): Promise<Item> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Item;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item>(null as any);
    }

    /**
     * Retrieves a list of CaseDeadlines for the specified languageCode .
     * @param languageCode The three-letter ISO-code for the country.
     * @return Success
     * @deprecated
     */
    getCaseDeadlines(languageCode: string): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/Case/GetCaseDeadlines/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseDeadlines(_response);
        });
    }

    protected processGetCaseDeadlines(response: Response): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Item[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * Retrieves a list of CaseDeadlines.
     * @return Success
     */
    getCaseDeadlines2(): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/Case/GetCaseDeadlines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseDeadlines2(_response);
        });
    }

    protected processGetCaseDeadlines2(response: Response): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Item[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * Retrieves a list of languages .
     * @return Success
     */
    getLanguages(): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/Case/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Item[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * @param callCenterCountryCode (optional) 
     * @return Success
     */
    getSmsTemplates(callCenterCountryCode: string | undefined): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/Case/GetSmsTemplates?";
        if (callCenterCountryCode === null)
            throw new Error("The parameter 'callCenterCountryCode' cannot be null.");
        else if (callCenterCountryCode !== undefined)
            url_ += "callCenterCountryCode=" + encodeURIComponent("" + callCenterCountryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSmsTemplates(_response);
        });
    }

    protected processGetSmsTemplates(response: Response): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Item[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item[]>(null as any);
    }
}

export interface ICaseActionClient {

    /**
     * Create a new caseAction of type External Note.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionExternalNote(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a new caseAction of type Internal Note.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionInternalNote(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a new caseAction of type Note To CaseHandler.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionNoteToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a new caseAction of type Note To Dispatch.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionNoteToDispatch(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a new caseAction of type Deviation To CaseHandler.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionDeviationToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a new caseAction of type Complaints To Note To CaseHandler.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionComplaintsToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a new caseAction of type Note To CaseHandler.
     * @param body (optional) The caseAction that will be created.
     * @return Success
     */
    createCaseActionAdditionalServiceToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction>;

    /**
     * Create a payment guarantee for the case.
     * @param body (optional) Encapsulates the case identifier VIS Logg Services 'tjeneste' code.
     * @return Success
     */
    createPaymentGuarantee(body: CreatePaymentGuaranteeCommand | undefined): Promise<PaymentGuaranteeResult>;

    /**
     * Create a new caseAction with payment guarantee.
     * @param body (optional) The caseAction that will be created.
     * @return Success
     */
    createCaseActionAdditionalServiceWithPaymentGuarantee(body: CreateCaseActionPaymentGuaranteeCommand | undefined): Promise<CaseAction>;

    /**
     * Get CaseActions by caseId caseId.
     * @param caseId (optional) 
     * @return Success
     */
    getCaseActionsByCaseId(caseId: string | undefined): Promise<CaseActionsWrapper>;
}

export class CaseActionClient extends ApiBase implements ICaseActionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a new caseAction of type External Note.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionExternalNote(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionExternalNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionExternalNote(_response);
        });
    }

    protected processCreateCaseActionExternalNote(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a new caseAction of type Internal Note.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionInternalNote(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionInternalNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionInternalNote(_response);
        });
    }

    protected processCreateCaseActionInternalNote(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a new caseAction of type Note To CaseHandler.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionNoteToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionNoteToCaseHandler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionNoteToCaseHandler(_response);
        });
    }

    protected processCreateCaseActionNoteToCaseHandler(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a new caseAction of type Note To Dispatch.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionNoteToDispatch(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionNoteToDispatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionNoteToDispatch(_response);
        });
    }

    protected processCreateCaseActionNoteToDispatch(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a new caseAction of type Deviation To CaseHandler.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionDeviationToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionDeviationToCaseHandler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionDeviationToCaseHandler(_response);
        });
    }

    protected processCreateCaseActionDeviationToCaseHandler(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a new caseAction of type Complaints To Note To CaseHandler.
     * @param body (optional) The case that will be created.
     * @return Success
     */
    createCaseActionComplaintsToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionComplaintsToCaseHandler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionComplaintsToCaseHandler(_response);
        });
    }

    protected processCreateCaseActionComplaintsToCaseHandler(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a new caseAction of type Note To CaseHandler.
     * @param body (optional) The caseAction that will be created.
     * @return Success
     */
    createCaseActionAdditionalServiceToCaseHandler(body: CaseActionDto | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionAdditionalServiceToCaseHandler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionAdditionalServiceToCaseHandler(_response);
        });
    }

    protected processCreateCaseActionAdditionalServiceToCaseHandler(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Create a payment guarantee for the case.
     * @param body (optional) Encapsulates the case identifier VIS Logg Services 'tjeneste' code.
     * @return Success
     */
    createPaymentGuarantee(body: CreatePaymentGuaranteeCommand | undefined): Promise<PaymentGuaranteeResult> {
        let url_ = this.baseUrl + "/api/CaseAction/CreatePaymentGuarantee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePaymentGuarantee(_response);
        });
    }

    protected processCreatePaymentGuarantee(response: Response): Promise<PaymentGuaranteeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentGuaranteeResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentGuaranteeResult>(null as any);
    }

    /**
     * Create a new caseAction with payment guarantee.
     * @param body (optional) The caseAction that will be created.
     * @return Success
     */
    createCaseActionAdditionalServiceWithPaymentGuarantee(body: CreateCaseActionPaymentGuaranteeCommand | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/CaseAction/CreateCaseActionAdditionalServiceWithPaymentGuarantee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActionAdditionalServiceWithPaymentGuarantee(_response);
        });
    }

    protected processCreateCaseActionAdditionalServiceWithPaymentGuarantee(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Get CaseActions by caseId caseId.
     * @param caseId (optional) 
     * @return Success
     */
    getCaseActionsByCaseId(caseId: string | undefined): Promise<CaseActionsWrapper> {
        let url_ = this.baseUrl + "/api/CaseAction/GetCaseActionsByCaseId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseActionsByCaseId(_response);
        });
    }

    protected processGetCaseActionsByCaseId(response: Response): Promise<CaseActionsWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseActionsWrapper;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseActionsWrapper>(null as any);
    }
}

export interface ICommunicationClient {

    /**
     * Sends a free-text SMS to the specified phone number.
     * @param body (optional) 
     * @return Success
     */
    sendFreeTextSms(body: SMS | undefined): Promise<CaseAction>;

    /**
     * Send a geo location sms to the specified number.
     * @param body (optional) 
     * @return Success
     */
    sendGeoLinkSms(body: SMS | undefined): Promise<CaseAction>;
}

export class CommunicationClient extends ApiBase implements ICommunicationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Sends a free-text SMS to the specified phone number.
     * @param body (optional) 
     * @return Success
     */
    sendFreeTextSms(body: SMS | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/Communication/SendFreeTextSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendFreeTextSms(_response);
        });
    }

    protected processSendFreeTextSms(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }

    /**
     * Send a geo location sms to the specified number.
     * @param body (optional) 
     * @return Success
     */
    sendGeoLinkSms(body: SMS | undefined): Promise<CaseAction> {
        let url_ = this.baseUrl + "/api/Communication/SendGeoLinkSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendGeoLinkSms(_response);
        });
    }

    protected processSendGeoLinkSms(response: Response): Promise<CaseAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseAction;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAction>(null as any);
    }
}

export interface IExternalVehicleInfoClient {

    /**
     * Perform a query to retrieve all sources used for search in the EVI api.
     * @return Success
     */
    getDataSources(): Promise<ComboboxItem[]>;

    /**
     * Perform a coverage search to determine if a vehicle has roadside assistance covered.
     * @param body (optional) 
     * @return Success
     */
    dekningsSok(body: SokDekningRequest | undefined): Promise<SokDekningResultat>;

    /**
     * Not relevant.
     * @param body (optional) 
     * @return Success
     */
    skadeSok(body: SokSkadeRequest | undefined): Promise<SokSkadeResultat>;

    /**
     * Get technical information about a vehicle from authorities.
     * @param body (optional) 
     * @return Success
     */
    tekniskSok(body: SokTekniskRequest | undefined): Promise<TekniskSokResultat>;
}

export class ExternalVehicleInfoClient extends ApiBase implements IExternalVehicleInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Perform a query to retrieve all sources used for search in the EVI api.
     * @return Success
     */
    getDataSources(): Promise<ComboboxItem[]> {
        let url_ = this.baseUrl + "/api/ExternalVehicleInfo/GetDataSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataSources(_response);
        });
    }

    protected processGetDataSources(response: Response): Promise<ComboboxItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComboboxItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComboboxItem[]>(null as any);
    }

    /**
     * Perform a coverage search to determine if a vehicle has roadside assistance covered.
     * @param body (optional) 
     * @return Success
     */
    dekningsSok(body: SokDekningRequest | undefined): Promise<SokDekningResultat> {
        let url_ = this.baseUrl + "/api/ExternalVehicleInfo/DekningsSok";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDekningsSok(_response);
        });
    }

    protected processDekningsSok(response: Response): Promise<SokDekningResultat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SokDekningResultat;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SokDekningResultat>(null as any);
    }

    /**
     * Not relevant.
     * @param body (optional) 
     * @return Success
     */
    skadeSok(body: SokSkadeRequest | undefined): Promise<SokSkadeResultat> {
        let url_ = this.baseUrl + "/api/ExternalVehicleInfo/SkadeSok";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSkadeSok(_response);
        });
    }

    protected processSkadeSok(response: Response): Promise<SokSkadeResultat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SokSkadeResultat;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SokSkadeResultat>(null as any);
    }

    /**
     * Get technical information about a vehicle from authorities.
     * @param body (optional) 
     * @return Success
     */
    tekniskSok(body: SokTekniskRequest | undefined): Promise<TekniskSokResultat> {
        let url_ = this.baseUrl + "/api/ExternalVehicleInfo/TekniskSok";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTekniskSok(_response);
        });
    }

    protected processTekniskSok(response: Response): Promise<TekniskSokResultat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TekniskSokResultat;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TekniskSokResultat>(null as any);
    }
}

export interface IPhoneLookUpClient {

    /**
     * Get a Person Looked up by phoneNumber through Eniro API phoneNumber.
     * @param phoneNumber (optional) 
     * @param countryCode (optional) 
     * @param callCenter (optional) 
     * @return Success
     */
    phoneLookupPersonRequest(phoneNumber: string | undefined, countryCode: string | undefined, callCenter: string | undefined): Promise<ResultDto>;

    /**
     * Get a Company Looked up by phoneNumber through Eniro API phoneNumber.
     * @param phoneNumber (optional) 
     * @param countryCode (optional) 
     * @param callCenter (optional) 
     * @return Success
     */
    phoneLookupCompanyRequest(phoneNumber: string | undefined, countryCode: string | undefined, callCenter: string | undefined): Promise<ResultDto>;
}

export class PhoneLookUpClient extends ApiBase implements IPhoneLookUpClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a Person Looked up by phoneNumber through Eniro API phoneNumber.
     * @param phoneNumber (optional) 
     * @param countryCode (optional) 
     * @param callCenter (optional) 
     * @return Success
     */
    phoneLookupPersonRequest(phoneNumber: string | undefined, countryCode: string | undefined, callCenter: string | undefined): Promise<ResultDto> {
        let url_ = this.baseUrl + "/api/PhoneLookUp/PhoneLookupPersonRequest?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (callCenter === null)
            throw new Error("The parameter 'callCenter' cannot be null.");
        else if (callCenter !== undefined)
            url_ += "callCenter=" + encodeURIComponent("" + callCenter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPhoneLookupPersonRequest(_response);
        });
    }

    protected processPhoneLookupPersonRequest(response: Response): Promise<ResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultDto>(null as any);
    }

    /**
     * Get a Company Looked up by phoneNumber through Eniro API phoneNumber.
     * @param phoneNumber (optional) 
     * @param countryCode (optional) 
     * @param callCenter (optional) 
     * @return Success
     */
    phoneLookupCompanyRequest(phoneNumber: string | undefined, countryCode: string | undefined, callCenter: string | undefined): Promise<ResultDto> {
        let url_ = this.baseUrl + "/api/PhoneLookUp/PhoneLookupCompanyRequest?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (callCenter === null)
            throw new Error("The parameter 'callCenter' cannot be null.");
        else if (callCenter !== undefined)
            url_ += "callCenter=" + encodeURIComponent("" + callCenter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPhoneLookupCompanyRequest(_response);
        });
    }

    protected processPhoneLookupCompanyRequest(response: Response): Promise<ResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultDto>(null as any);
    }
}

export interface IRetailerClient {

    /**
     * Retrieves a list of Retailers codes for the specified latitude and longitude.
     * @param latitude Latitude.
     * @param longitude Longitude.
     * @param withDistance (optional) When true, calculate distances via gmaps distance api.
     * @return Success
     */
    getNearByRetailers(latitude: number, longitude: number, withDistance: boolean | undefined): Promise<LocationDto[]>;

    /**
     * Retrieves a list of RentalCarProvidor codes for the specified latitude and longitude.
     * @param latitude Latitude.
     * @param longitude Longitude.
     * @param withDistance (optional) When true, calculate distances via gmaps distance api.
     * @return Success
     */
    getNearbyRentalCarProviders(latitude: number, longitude: number, withDistance: boolean | undefined): Promise<LocationDto[]>;

    /**
     * Returns a list of RentalCarProviders.
     * @return Success
     */
    getRentalCarProviders2(): Promise<RentalCarProviderDto[]>;
}

export class RetailerClient extends ApiBase implements IRetailerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrieves a list of Retailers codes for the specified latitude and longitude.
     * @param latitude Latitude.
     * @param longitude Longitude.
     * @param withDistance (optional) When true, calculate distances via gmaps distance api.
     * @return Success
     */
    getNearByRetailers(latitude: number, longitude: number, withDistance: boolean | undefined): Promise<LocationDto[]> {
        let url_ = this.baseUrl + "/api/Retailer/GetNearByRetailers?";
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (withDistance === null)
            throw new Error("The parameter 'withDistance' cannot be null.");
        else if (withDistance !== undefined)
            url_ += "withDistance=" + encodeURIComponent("" + withDistance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNearByRetailers(_response);
        });
    }

    protected processGetNearByRetailers(response: Response): Promise<LocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto[]>(null as any);
    }

    /**
     * Retrieves a list of RentalCarProvidor codes for the specified latitude and longitude.
     * @param latitude Latitude.
     * @param longitude Longitude.
     * @param withDistance (optional) When true, calculate distances via gmaps distance api.
     * @return Success
     */
    getNearbyRentalCarProviders(latitude: number, longitude: number, withDistance: boolean | undefined): Promise<LocationDto[]> {
        let url_ = this.baseUrl + "/api/Retailer/GetNearbyRentalCarProviders?";
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (withDistance === null)
            throw new Error("The parameter 'withDistance' cannot be null.");
        else if (withDistance !== undefined)
            url_ += "withDistance=" + encodeURIComponent("" + withDistance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNearbyRentalCarProviders(_response);
        });
    }

    protected processGetNearbyRentalCarProviders(response: Response): Promise<LocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto[]>(null as any);
    }

    /**
     * Returns a list of RentalCarProviders.
     * @return Success
     */
    getRentalCarProviders2(): Promise<RentalCarProviderDto[]> {
        let url_ = this.baseUrl + "/api/Retailer/GetRentalCarProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRentalCarProviders2(_response);
        });
    }

    protected processGetRentalCarProviders2(response: Response): Promise<RentalCarProviderDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalCarProviderDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalCarProviderDto[]>(null as any);
    }
}

export interface IUserClient {

    /**
     * Gets the user object for the current user.
     * @return Success
     */
    getUserProfile(): Promise<UserDto>;

    /**
     * Get list of users.
     * @return Success
     */
    getUsers(): Promise<UserDto[]>;

    /**
     * Allows a user to set their own call center and language.
     * @param body (optional) Update profile command.
     * @return Success
     */
    updateUserProfile(body: UpdateProfileCommand | undefined): Promise<boolean>;

    /**
     * Fetches the list of roles.
     * @return Success
     */
    getRoles(): Promise<Role[]>;
}

export class UserClient extends ApiBase implements IUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the user object for the current user.
     * @return Success
     */
    getUserProfile(): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Get list of users.
     * @return Success
     */
    getUsers(): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * Allows a user to set their own call center and language.
     * @param body (optional) Update profile command.
     * @return Success
     */
    updateUserProfile(body: UpdateProfileCommand | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/UpdateUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserProfile(_response);
        });
    }

    protected processUpdateUserProfile(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Fetches the list of roles.
     * @return Success
     */
    getRoles(): Promise<Role[]> {
        let url_ = this.baseUrl + "/api/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role[]>(null as any);
    }
}

export interface IUserAdminClient {

    /**
     * Update an existing user.
     * @param userId User id.
     * @param body (optional) Update user command for admins.
     * @return Success
     */
    updateUser(userId: string, body: AdminUpdateUserCommand | undefined): Promise<boolean>;

    /**
     * Deactivates the user.
     * @param body (optional) User id.
     * @return Success
     */
    deactivateUser(body: string | undefined): Promise<boolean>;

    /**
     * Activates the user.
     * @param body (optional) User id.
     * @return Success
     */
    activateUser(body: string | undefined): Promise<boolean>;

    /**
     * Create a new user.
     * @param body (optional) Create user command.
     * @return Success
     */
    createUser(body: CreateUserCommand | undefined): Promise<UserDto>;
}

export class UserAdminClient extends ApiBase implements IUserAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Update an existing user.
     * @param userId User id.
     * @param body (optional) Update user command for admins.
     * @return Success
     */
    updateUser(userId: string, body: AdminUpdateUserCommand | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserAdmin/UpdateUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Deactivates the user.
     * @param body (optional) User id.
     * @return Success
     */
    deactivateUser(body: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserAdmin/DeactivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateUser(_response);
        });
    }

    protected processDeactivateUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Activates the user.
     * @param body (optional) User id.
     * @return Success
     */
    activateUser(body: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserAdmin/ActivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateUser(_response);
        });
    }

    protected processActivateUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Create a new user.
     * @param body (optional) Create user command.
     * @return Success
     */
    createUser(body: CreateUserCommand | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/UserAdmin/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export interface ICaseHubClient {

    geolocationReceived(message: GeolocationReceived | undefined): Promise<void>;
}

export class CaseHubClient extends ApiBase implements ICaseHubClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    geolocationReceived(message: GeolocationReceived | undefined): Promise<void> {
        let url_ = this.baseUrl + "/hubs/CaseHub/GeolocationReceived?";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeolocationReceived(_response);
        });
    }

    protected processGeolocationReceived(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export enum OrderDirectionEnum {
    Ascending = "ascending",
    Descending = "descending",
}

export interface CreateCaseActionPaymentGuaranteeCommand {
    message?: string | undefined;
    recipient?: string | undefined;
    caseId?: string | undefined;
    type?: string | undefined;
    service?: string | undefined;
    distributedToName?: string | undefined;
    distributedToId?: number | undefined;
    description?: string | undefined;
    source?: string | undefined;
    setDistributedInformation?: boolean;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface CreatePaymentGuaranteeCommand {
    serviceCode?: string | undefined;
    message?: string | undefined;
    caseId?: string | undefined;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface PaymentGuaranteeResult {
    templateText?: string | undefined;
}

export interface CancelCaseCommand {
    caseId?: string | undefined;
    reasonId?: string | undefined;
    description?: string | undefined;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface FixedItCommand {
    caseId?: string | undefined;
    description?: string | undefined;
    reasonId?: string | undefined;
    type?: FixedItType;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export enum FixedItType {
    InfoCall = "infoCall",
    PhoneFix = "phoneFix",
}

export interface ResumeCaseCommand {
    caseId?: string | undefined;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export enum CaseSearchOrderKey {
    VisCaseId = "visCaseId",
    RegistrationNumber = "registrationNumber",
    IncidentDate = "incidentDate",
    IncidentReason = "incidentReason",
    IncidentCityAndCountry = "incidentCityAndCountry",
    MakeAndModel = "makeAndModel",
    Owner = "owner",
    Workshop = "workshop",
}

export interface CaseSearchRequest {
    resultPage?: number;
    resultQty?: number;
    orderBy?: CaseSearchOrderKey;
    orderDirection?: OrderDirectionEnum;
    filters?: CaseSearchRequestFilters;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
}

export interface CaseSearchRequestFilters {
    caseId?: string | undefined;
    visCaseId?: number | undefined;
    registrationNumber?: string | undefined;
    ownerName?: string | undefined;
    incidentDateTimeFrom?: Date | undefined;
    incidentDateTimeTo?: Date | undefined;
    incidentAdress?: string | undefined;
    incidentPostalArea?: string | undefined;
    incidentCountryCode?: string | undefined;
    caseStatusIds?: number[] | undefined;
    sourceOfCaseInformationCode?: string | undefined;
    vin?: string | undefined;
    brandCode?: string | undefined;
    modelCode?: string | undefined;
    ownerPhoneNumberCountryCode?: string | undefined;
    ownerPhoneNumber?: string | undefined;
    contactPersonName?: string | undefined;
    contactPersonPhoneNumberCountryCode?: string | undefined;
    contactPersonPhoneNumber?: string | undefined;
    incidentTypeCode?: string | undefined;
    agreementCode?: string | undefined;
    insuranceStatusCode?: string | undefined;
    insuranceReferenceNumber?: string | undefined;
    workshopId?: number | undefined;
    processingLocationName?: string | undefined;
    caseAgentId?: string | undefined;
    caseRegisteredDateTimeFrom?: Date | undefined;
    caseRegisteredDateTimeTo?: Date | undefined;
    logRegisteredDateTimeFrom?: Date | undefined;
    logRegisteredDateTimeTo?: Date | undefined;
    logFromCallCenterCode?: string | undefined;
    logFromAgentId?: string | undefined;
    logCode?: string | undefined;
    serviceCode?: string | undefined;
    deadlineDateTimeFrom?: Date | undefined;
    deadlineDateTimeTo?: Date | undefined;
    completedDateTimeFrom?: Date | undefined;
    completetDateTimeTo?: Date | undefined;
    logTransferredToId?: number | undefined;
    createdDate?: Date | undefined;
}

export interface SendCaseToVikingCommand {
    caseId?: string | undefined;
    serviceType?: string | undefined;
    description?: string | undefined;
    channel?: string | undefined;
    degreeOfUrgency?: string | undefined;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface AdminUpdateUserCommand {
    languageCode?: string | undefined;
    callCenterCountryCode?: string | undefined;
    roleId?: number | undefined;
    email?: string | undefined;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface CreateUserCommand {
    email?: string | undefined;
    visUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    callCenterCountryCode?: string | undefined;
    languageCode?: string | undefined;
    roleId?: number;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface UpdateProfileCommand {
    languageCode?: string | undefined;
    callCenterCountryCode?: string | undefined;
    visUserIdClaim?: string | undefined;
    languageCodeClaim?: string | undefined;
    readonly correlationId?: string | undefined;
}

export interface Actor {
    id?: string | undefined;
    visActorId?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    location?: Location;
    createdDate?: Date;
    lastChanged?: Date;
}

export enum ActorTypeEnum {
    Owner = "owner",
    Caller = "caller",
    Driver = "driver",
}

export interface CaseAction {
    id?: string | undefined;
    caseId?: string | undefined;
    visLoggId?: number | undefined;
    visLoggTypeCode?: string | undefined;
    visLoggServiceCode?: string | undefined;
    description?: string | undefined;
    registeredDateTime?: Date;
    distributedDateTime?: Date | undefined;
    distributedToId?: number | undefined;
    distributedToName?: string | undefined;
    distributedBy?: string | undefined;
    etaDriverDateTime?: Date | undefined;
    estaDriverDateTime?: Date | undefined;
    customerContactedDateTime?: Date | undefined;
    customerContactedBy?: string | undefined;
    enRouteDateTime?: Date | undefined;
    enRouteBy?: string | undefined;
    arrivalDateTime?: Date | undefined;
    arrivalBy?: string | undefined;
    loadedDateTime?: Date | undefined;
    loadedBy?: string | undefined;
    completedDateTime?: Date | undefined;
    completedBy?: string | undefined;
    responsible?: string | undefined;
    source?: string | undefined;
}

export interface Company {
    id?: number | undefined;
    name?: string | undefined;
}

export interface GeolocationReceived {
    oppdragId?: number;
    phoneNumber?: string | undefined;
    addressDto?: AddressDto;
}

export interface Location {
    id?: string | undefined;
    description?: string | undefined;
    street?: string | undefined;
    postalArea?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export interface Role {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export interface Agreement {
    id?: string | undefined;
    name?: string | undefined;
}

export interface BrandDto {
    id?: string | undefined;
    name?: string | undefined;
}

export interface CaseActionDto {
    caseId?: string | undefined;
    service?: string | undefined;
    description?: string | undefined;
    distributedToName?: string | undefined;
    distributedToId?: number | undefined;
    source?: string | undefined;
}

export interface CaseActionsWrapper {
    actions?: CaseAction[] | undefined;
    services?: CaseAction[] | undefined;
}

export interface CaseActorDto {
    actor?: Actor;
    actorType?: ActorTypeEnum;
    driver?: boolean;
    contactPerson?: boolean;
}

export interface CaseDto {
    id?: string | undefined;
    visCaseId?: number | undefined;
    title?: string | undefined;
    incident?: IncidentDto;
    insurance?: InsuranceDto;
    vehicle?: VehicleDto;
    agreement?: Agreement;
    workshop?: WorkshopDto;
    statusId?: number | undefined;
    caseOriginCode?: string | undefined;
    actors?: CaseActorDto[] | undefined;
    createdDate?: Date;
    lastChanged?: Date;
    leasingTaker?: string | undefined;
    callCenterId?: number | undefined;
    callCenterCountry?: string | undefined;
}

export interface CaseSearchResultDto {
    caseId?: string | undefined;
    visCaseId?: number;
    registrationNumber?: string | undefined;
    stateOfCase?: string | undefined;
    statusId?: number | undefined;
    incidentDateTime?: Date | undefined;
    incidentPostalArea?: string | undefined;
    incidentCountry?: string | undefined;
    incidentType?: string | undefined;
    vehicleBrand?: string | undefined;
    vehicledModel?: string | undefined;
    makeModel?: string | undefined;
    owner?: string | undefined;
    processingLocation?: string | undefined;
    createdDate?: Date | undefined;
    callCenterId?: number | undefined;
    callCenterCountry?: string | undefined;
}

export interface CaseSearchResultsDto {
    caseSearchResults?: CaseSearchResultDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalNumberOfResults?: number;
}

export interface IncidentDto {
    description?: string | undefined;
    incidentDetailTypeCode?: string | undefined;
    time?: Date | undefined;
    waitingInfo?: string | undefined;
    waitingInfoDescription?: string | undefined;
    keyPlacementCode?: string | undefined;
    incidentTypeCode?: string | undefined;
    location?: Location;
}

export interface InsuranceDto {
    id?: string | undefined;
    insuranceCompany?: Company;
    reference?: string | undefined;
    type?: string | undefined;
    deductible?: number | undefined;
    statusCode?: string | undefined;
    readOnlyInfo?: string | undefined;
}

export interface ModelDto {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SMS {
    visCaseId?: number;
    caseId?: string | undefined;
    messageText?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface UserDto {
    id?: string | undefined;
    email?: string | undefined;
    visUserId?: string | undefined;
    company?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    callCenterCountryCode?: string | undefined;
    callCenterId?: number | undefined;
    active?: boolean | undefined;
    languageCode?: string | undefined;
    role?: Role;
    lastLogin?: Date | undefined;
    canUpdateEmail?: boolean;
}

export interface VehicleDto {
    vin?: string | undefined;
    registrationNumber?: string | undefined;
    vehicleTypeCode?: string | undefined;
    weight?: number | undefined;
    maximumAllowableWeight?: number | undefined;
    model?: ModelDto;
    brand?: BrandDto;
    makeModel?: string | undefined;
    modelYear?: number | undefined;
    driveTrain?: string | undefined;
    fuelType?: string | undefined;
    isUsedCommercially?: boolean;
    currentKmSum?: number | undefined;
    lastServiceKmSum?: number | undefined;
    lastServiceDate?: Date | undefined;
    firstRegistrationDate?: Date | undefined;
    lastRegistrationDate?: Date | undefined;
    originalDealerVisId?: number | undefined;
    originalDealerName?: string | undefined;
    lastServiceValidUntilKm?: number | undefined;
    lastServiceValidUntilDate?: Date | undefined;
    lastServiceLocationVisId?: number | undefined;
    lastServiceLocationName?: string | undefined;
}

export interface WorkshopDto {
    name?: string | undefined;
    description?: string | undefined;
    visId?: string | undefined;
    phoneNumber?: string | undefined;
    transportTo?: Location;
}

export interface DatakildeFeil {
    datakilde?: string | undefined;
    feiltype?: Feiltype;
    errorMessage?: string | undefined;
}

export interface DekningResultat {
    eksternMerke?: string | undefined;
    merke?: string | undefined;
    merkeNavn?: string | undefined;
    modell?: string | undefined;
    modellNavn?: string | undefined;
    merkeModell?: string | undefined;
    merkeModellKonkat?: string | undefined;
    kilde?: string | undefined;
    eksternId?: number | undefined;
    kundeProgram?: string | undefined;
    avtale?: string | undefined;
    objektType?: string | undefined;
    objektNr?: string | undefined;
    farge?: string | undefined;
    eierJE?: number | undefined;
    medlemNr?: number | undefined;
    medlemGruppe?: string | undefined;
    medlemUnderGruppe?: string | undefined;
    medlemKonkat?: string | undefined;
    eiere?: Eier[] | undefined;
    eierNavn?: string | undefined;
    eierAdresse?: string | undefined;
    eierPostNr?: string | undefined;
    eierPostSted?: string | undefined;
    eierLand?: string | undefined;
    eierTlf?: string | undefined;
    eierEpost?: string | undefined;
    jeForsikringselskap?: number | undefined;
    forsikringsselskapNavn?: string | undefined;
    poliseNr?: string | undefined;
    forfall?: Date | undefined;
    refNr?: string | undefined;
    avtalepartnersRefNr?: string | undefined;
    egenandel?: string | undefined;
    dekning?: string | undefined;
    arsModell?: number | undefined;
    sisteRegDato?: Date | undefined;
    forsteRegDato?: Date | undefined;
    chassisNr?: string | undefined;
    maxKmStand?: number | undefined;
    fraDato?: Date | undefined;
    tilDato?: Date | undefined;
    fraDatoMedTidssone?: string | undefined;
    tilDatoMedTidssone?: string | undefined;
    sortering?: string | undefined;
    "stjåletDato"?: Date | undefined;
    avregDato?: Date | undefined;
    vraketDato?: Date | undefined;
    leietakerNavn?: string | undefined;
    leietakerAdresse?: string | undefined;
    leietakerPostNr?: string | undefined;
    leietakerPostSted?: string | undefined;
    leietakerLand?: string | undefined;
    solgtTilNavn?: string | undefined;
    solgtTilAdresse?: string | undefined;
    solgtTilPostNr?: string | undefined;
    solgtTilPostSted?: string | undefined;
    solgtTilLand?: string | undefined;
    "kjøretøyType"?: string | undefined;
    drivstoff?: string | undefined;
    drivverk?: string | undefined;
    erAvskiltet?: boolean;
    kanKopieresFra?: boolean;
    tillattTotalVekt?: number | undefined;
    vekt?: number | undefined;
    fnrOrgnr?: string | undefined;
    "kjøretøyStatus"?: string | undefined;
    forhandlerJE?: number | undefined;
    forhandlerJENavn?: string | undefined;
    sisteServiceForhandlerJE?: number | undefined;
    sisteServiceForhandlerNavn?: string | undefined;
    sisteServiceGyldigTilKm?: number | undefined;
    sisteServiceGyldigTilDato?: Date | undefined;
    yrkesTrafikk?: boolean | undefined;
    yrkesTrafikkNavn?: string | undefined;
    yrkesTrafikkFraDato?: Date | undefined;
    oppdragDetTekst?: string | undefined;
    sisteServiceTilDato?: Date | undefined;
    sisteServiceTilKm?: number | undefined;
    viktigDekningsInfo?: boolean;
    skalIkkeKopiereForsikring?: boolean;
    manualGear?: boolean;
    automaticGear?: boolean;
    frontWheelDrive?: boolean;
    backWheelDrive?: boolean;
    allWheelDrive?: boolean;
    isElectric?: boolean;
    chassisTypeBeskrivelse?: string | undefined;
    antallDorer?: string | undefined;
    girkasseBeskrivelse?: string | undefined;
    antallSeter?: number | undefined;
    lengde?: number | undefined;
    bredde?: number | undefined;
    hoyde?: number | undefined;
    dekkBeskrivelse?: string | undefined;
    garantiAvtaleNavn?: string | undefined;
    garanti?: string | undefined;
    mvTilleggsinfo?: string | undefined;
    eksternKontraktKode?: string | undefined;
    eksternKjoretoyBeskrivelse?: string | undefined;
    feilmeldinger?: ErrorMessage[] | undefined;
}

export interface DekningsSokParameters {
    skadeTidspunkt?: Date | undefined;
    regNr?: string | undefined;
    chassisNr?: string | undefined;
    "skadeårsak"?: string | undefined;
    navn?: string | undefined;
    poststed?: string | undefined;
    merke?: string | undefined;
    merkekode?: string | undefined;
    personNr?: string | undefined;
    poliseNr?: string | undefined;
    loyveNr?: string | undefined;
    telefonNr?: string | undefined;
    epost?: string | undefined;
    jeForsikringSelskap?: number | undefined;
    oppdrag?: number;
    bruker?: string | undefined;
    "søkeSekvens"?: number;
    land?: string | undefined;
    poliseNrEllerMedlemsNr?: string | undefined;
    "kjøretøytypeFinland"?: number;
}

export interface Eier {
    navn?: string | undefined;
    adresse?: string | undefined;
    postNr?: string | undefined;
    postSted?: string | undefined;
    land?: string | undefined;
    tlf?: string | undefined;
    epost?: string | undefined;
}

export interface ErrorMessage {
    api?: string | undefined;
    status?: string | undefined;
    error?: string | undefined;
}

export enum Feiltype {
    Timeout = "Timeout",
    Autentisering = "Autentisering",
    Generell = "Generell",
}

export interface Polise {
    eksternJE?: number | undefined;
    poliseNr?: string | undefined;
    regNr?: string | undefined;
}

export interface Skade {
    skadenummer?: string | undefined;
    skadedelnummer?: string | undefined;
    skadedato?: Date | undefined;
    skadeRapporertdato?: Date | undefined;
    saksbehandler?: string | undefined;
    saksbehandlerEpost?: string | undefined;
    "årsak"?: string | undefined;
    dekkerBilleie?: boolean;
    isLeasing?: boolean;
    hybridInfo?: string | undefined;
    hybridInfoText?: string | undefined;
    markeNamn?: string | undefined;
    momentText?: string | undefined;
    momentDeductibleText?: string | undefined;
    momentDeductible?: number | undefined;
    momentPaymentCommitment?: boolean | undefined;
    poliseNr?: string | undefined;
}

export interface SokDekningRequest {
    datakilder?: string[] | undefined;
    "søkeParametere"?: DekningsSokParameters;
}

export interface SokDekningResultat {
    dekninger?: DekningResultat[] | undefined;
    feiledeDatakilder?: DatakildeFeil[] | undefined;
}

export interface SokSkadeRequest {
    datakilde?: string | undefined;
    "søkeParametere"?: DekningsSokParameters;
}

export interface SokSkadeResultat {
    eksternMerke?: string | undefined;
    merke?: string | undefined;
    merkeNavn?: string | undefined;
    modell?: string | undefined;
    modellNavn?: string | undefined;
    merkeModell?: string | undefined;
    merkeModellKonkat?: string | undefined;
    polise?: Polise;
    skader?: Skade[] | undefined;
    eksternForsikringsJE?: string | undefined;
    forsikringJE?: number | undefined;
    forsikringJENavn?: string | undefined;
    eksternDrivstoff?: string | undefined;
    drivstoff?: string | undefined;
    "eksternKjøretøyType"?: string | undefined;
    "kjøretøyType"?: string | undefined;
}

export interface SokTekniskRequest {
    datakilde?: string | undefined;
    "søkeParametere"?: DekningsSokParameters;
}

export interface TekniskSokResultat {
    eksternMerke?: string | undefined;
    merke?: string | undefined;
    merkeNavn?: string | undefined;
    modell?: string | undefined;
    modellNavn?: string | undefined;
    merkeModell?: string | undefined;
    merkeModellKonkat?: string | undefined;
    regNr?: string | undefined;
    eier?: string | undefined;
    chassis?: string | undefined;
    forsteRegDato?: Date | undefined;
    vekt?: number | undefined;
    farge?: string | undefined;
    type?: string | undefined;
    motorytelse?: number | undefined;
    slagvolum?: number | undefined;
    bredde?: number | undefined;
    lengde?: number | undefined;
    antallAksler?: number | undefined;
    driftAntallAksler?: number | undefined;
    akselavstand1?: number | undefined;
    akselavstand2?: number | undefined;
    akselavstand3?: number | undefined;
    akselavstand4?: number | undefined;
    vektForaksel?: number | undefined;
    vektBakaksel?: number | undefined;
    tillatVektTot?: number | undefined;
    tillatVogntogVekt?: number | undefined;
    sitteplasserIAlt?: number | undefined;
    sitteplasserForan?: number | undefined;
    "ståplasser"?: number | undefined;
    stdDekkDimForan?: string | undefined;
    stdDekkDimBak?: string | undefined;
    stdFelgForan?: string | undefined;
    stdFelgBak?: string | undefined;
    akseltrykkForan?: number | undefined;
    akseltrykkBak?: number | undefined;
    "egenvektUFører"?: number | undefined;
    tilhengerMBrems?: number | undefined;
    tilhengerUBrems?: number | undefined;
    lasteplanlengde?: number | undefined;
    lengdeTilTilhKpl?: number | undefined;
    avskiltet?: Date | undefined;
    antallDorer?: string | undefined;
    girkasseBeskrivelse?: string | undefined;
    hoyde?: number | undefined;
    dekkBeskrivelse?: string | undefined;
    eksternForsikringsJE?: string | undefined;
    forsikringJE?: number | undefined;
    forsikringJENavn?: string | undefined;
    eksternDrivstoff?: string | undefined;
    drivstoff?: string | undefined;
    "eksternKjøretøyType"?: string | undefined;
    "kjøretøyType"?: string | undefined;
}

export interface Address {
    postalCode?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    postalArea?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
}

export interface Company2 {
    eniroId?: number | undefined;
    name?: string | undefined;
    profilePageLink?: string | undefined;
    phones?: CompanyPhone[] | undefined;
    addresses?: Address[] | undefined;
}

export interface CompanyPhone {
    number?: string | undefined;
    text?: string | undefined;
}

export interface Coordinates {
    lat?: string | undefined;
    lon?: string | undefined;
    type?: string | undefined;
}

export interface District {
    code?: string | undefined;
    extra?: string | undefined;
    geoId?: string | undefined;
    name?: string | undefined;
    rank?: string | undefined;
    type?: string | undefined;
}

export interface Hits {
    companies?: number | undefined;
}

export interface Name {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
}

export interface Person {
    eniroId?: number | undefined;
    districts?: District[] | undefined;
    name?: Name;
    phones?: Phone[] | undefined;
    addresses?: PersonAddress[] | undefined;
    birthDate?: string | undefined;
    nameDay?: string | undefined;
}

export interface PersonAddress {
    postalArea?: string | undefined;
    postalCode?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    municipality?: string | undefined;
    region?: string | undefined;
    province?: string | undefined;
    urbanArea?: string | undefined;
    borough?: string | undefined;
    neighborhood?: string | undefined;
    community?: string | undefined;
    metropolitanSubarea?: string | undefined;
    coordinates?: Coordinates[] | undefined;
    door?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
}

export interface Phone {
    number?: string | undefined;
}

export interface ResultDto {
    searchLevel?: string | undefined;
    hits?: Hits;
    companies?: Company2[] | undefined;
    persons?: Person[] | undefined;
}

export interface AddressDto {
    address?: string | undefined;
    postalPlace?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export interface AgreementDto {
    important?: string | undefined;
    details?: string | undefined;
    caseFields?: CaseFieldDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export interface CaseCoverageStatus {
    readonly isValid?: boolean;
    caseCoverageValidationErrors?: CaseCoverageValidationError[] | undefined;
}

export interface CaseCoverageStatusRequest {
    caseId?: string | undefined;
    agreementId?: string | undefined;
    incidentCode?: string | undefined;
    isAtHome?: boolean;
    makeId?: string | undefined;
    modelId?: string | undefined;
    weight?: number;
    mileage?: number;
    isUsedCommercially?: boolean;
    lastServiceDate?: Date | undefined;
    firstRegisteredDate?: Date;
}

export interface CaseCoverageValidationError {
    property?: string | undefined;
    validationMessage?: string | undefined;
    severity?: string | undefined;
}

export interface CaseFieldDto {
    caseFieldCode?: string | undefined;
    label?: string | undefined;
    message?: string | undefined;
    sort?: number;
    controlType?: string | undefined;
    requiredLevel?: string | undefined;
}

export interface ComboboxItem {
    tooltip?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export interface CoordinatesDto {
    latitude?: number;
    longitude?: number;
}

export interface DetailedRentalCarProviderDto {
    jeId?: number;
    name?: string | undefined;
    postalPlace?: string | undefined;
    postalCode?: string | undefined;
    adress?: string | undefined;
    country?: string | undefined;
    mainPhone?: string | undefined;
    comment?: string | undefined;
    emailAddress?: EmailAddressDto[] | undefined;
}

export interface Distance {
    valueInKm?: number;
    displayValue?: string | undefined;
    isAccurate?: boolean;
}

export interface EmailAddressDto {
    jeId?: number;
    address?: string | undefined;
    note?: string | undefined;
    sort?: number | undefined;
}

export interface Item {
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export interface LocationDto {
    distance?: Distance;
    coordinates?: CoordinatesDto;
    address?: AddressDto;
    rolleId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    tooltip?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export interface RentalCarProviderDto {
    rolleId?: string | undefined;
    tooltip?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}